'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import 'draft-js/dist/Draft.css'
// eslint-disable-next-line import/no-unresolved

// import { save } from 'redux/modules/saveUserData';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _draftJs = require('draft-js');

var _templateData = require('redux/modules/templateData');

var templateData = _interopRequireWildcard(_templateData);

var _semanticUiReact = require('semantic-ui-react');

require('./ActionVerbBox.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionVerbBox = (_dec = (0, _reactRedux.connect)(function (state) {
  return {

    verb_alternatives: state.templateData.verb_alternatives,
    loading_verb_alternatives: state.templateData.loading_verb_alternatives
  };
}, {
  loadVerbAlternatives: templateData.loadVerbAlternatives
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ActionVerbBox, _Component);

  function ActionVerbBox(props) {
    (0, _classCallCheck3.default)(this, ActionVerbBox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ActionVerbBox.__proto__ || (0, _getPrototypeOf2.default)(ActionVerbBox)).call(this, props));

    _this.showOptions = function (value) {
      return _this.setState({ optionsVisible: value });
    };

    _this.state = {
      optionsVisible: false,
      verb_alternatives: false,
      loading_verb_alternatives: false
    };
    return _this;
  }

  (0, _createClass3.default)(ActionVerbBox, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.verb_alternatives != this.props.verb_alternatives) {
        this.setState({ verb_alternatives: this.props.verb_alternatives });
      }
      if (prevProps.loading_verb_alternatives != this.props.loading_verb_alternatives) {
        this.setState({ loading_verb_alternatives: this.props.loading_verb_alternatives });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var actionVerbAlternates = ['created', 'developed', 'formulated', 'designed', 'conceptualized'];
      var _state = this.state,
          optionsVisible = _state.optionsVisible,
          verb_alternatives = _state.verb_alternatives,
          loading_verb_alternatives = _state.loading_verb_alternatives;
      var _props = this.props,
          editor = _props.editor,
          decoratedText = _props.decoratedText;

      var selection = this.props.children['0'].props;

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'span',
          { style: { background: 'orange', cursor: 'pointer' }, onClick: function onClick(e) {
              _this2.props.loadVerbAlternatives(decoratedText.toLowerCase());
              _this2.showOptions(true);
            } },
          this.props.children
        ),
        optionsVisible && _react2.default.createElement(
          _semanticUiReact.Card,
          { contentEditable: false, className: 'wordOptionsWrapper' },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'space-between', padding: '5px' } },
            _react2.default.createElement(
              'div',
              { style: { fontWeight: 'bold' } },
              'Options:'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { style: { cursor: 'pointer' }, name: 'close', onClick: function onClick(event) {
                event.stopPropagation();
                _this2.showOptions(false);
              }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'optionTextButton' },
            _react2.default.createElement(_semanticUiReact.Loader, { active: loading_verb_alternatives }),
            verb_alternatives && verb_alternatives.map(function (item, index) {
              return _react2.default.createElement(_semanticUiReact.Button, { color: 'blue', size: 'mini', key: item + '-' + index, content: item, onClick: function onClick(e) {
                  e.stopPropagation();
                  var selectionState = _draftJs.SelectionState.createEmpty(selection.block.key).merge({
                    anchorOffset: selection.start,
                    focusOffset: selection.start + decoratedText.length
                  });

                  var editorState = editor.state.editorState;
                  var newItem;
                  if (decoratedText[0] === decoratedText[0].toUpperCase()) {
                    newItem = item[0].toUpperCase() + item.substring(1);
                  } else {
                    newItem = item;
                  }

                  var newState = _draftJs.Modifier.replaceText(editorState.getCurrentContent(), selectionState, newItem, null, null);
                  var newEditorState = _draftJs.EditorState.push(editorState, newState, 'select-alternate-word');
                  editor.selectAlternateWord(newEditorState);
                }
              });
            })
          )
        )
      );
    }
  }]);
  return ActionVerbBox;
}(_react.Component)) || _class);
exports.default = ActionVerbBox;
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ActionVerbBox/ActionVerbBox.js
// module id = 1730
// module chunks = 0